import { ValueFormatterParams } from '@ag-grid-community/core'
import { getDepartment, getFamily, getSection } from 'utils/helpers'

export const FILTER_FIELD_PRICE_LABEL_REPORT = 'priceLabelReportFilters'

export const PRICE_LABEL_REPORT_FORM_FIELDS = {
  BARCODE: {
    key: 'barcode',
    label: 'Barcode',
  },
  NAME: {
    key: 'name',
    label: 'Name',
  },
  SAP_MATERIAL_NO: {
    key: 'sapMaterialNo',
    label: 'SAP Material Number',
  },
  DEPARTMENT: {
    key: 'dept',
    label: 'Department',
  },
  SECTION: {
    key: 'section',
    label: 'Section',
  },
  FAMILY: {
    key: 'family',
    label: 'Family',
  },
  SUB_FAMILY: {
    key: 'subFamily',
    label: 'Sub Family',
  },
  SAP_DEPARTMENT: {
    key: 'sapDept',
    label: 'SAP Department',
  },
  SAP_SECTION: {
    key: 'sapSection',
    label: 'SAP Section',
  },
  SAP_FAMILY: {
    key: 'sapFamily',
    label: 'SAP Family',
  },
  SAP_SUB_FAMILY: {
    key: 'sapSubFamily',
    label: 'SAP Sub Family',
  },
  STORE_ID: {
    key: 'storeId',
    label: 'Store',
  },
}

// Catalogue columns come back as null when the barcode is not in the catalogue
const orDash = (params: ValueFormatterParams) => params.value || '-'

export const columns = [
  {
    headerName: 'Barcode',
    field: 'barcode',
    minWidth: 150,
    valueFormatter: orDash,
  },
  {
    headerName: 'Name',
    field: 'name',
    minWidth: 220,
    valueFormatter: orDash,
  },
  {
    headerName: 'Pack Info',
    field: 'packInfo',
    valueFormatter: orDash,
  },
  {
    headerName: 'SAP Material Number',
    field: 'sapMaterialNo',
    minWidth: 200,
    valueFormatter: orDash,
  },
  {
    headerName: 'Department',
    field: 'dept',
    valueFormatter: (params: ValueFormatterParams) =>
      getDepartment(params.value),
  },
  {
    headerName: 'Section',
    field: 'section',
    valueFormatter: (params: ValueFormatterParams) => getSection(params.value),
  },
  {
    headerName: 'Family',
    field: 'family',
    valueFormatter: (params: ValueFormatterParams) => getFamily(params.value),
  },
  {
    headerName: 'Sub Family',
    field: 'subFamily',
    valueFormatter: orDash,
  },
  {
    headerName: 'SAP Department',
    field: 'sapDept',
    minWidth: 180,
    valueFormatter: (params: ValueFormatterParams) =>
      getDepartment(params.value),
  },
  {
    headerName: 'SAP Section',
    field: 'sapSection',
    minWidth: 160,
    valueFormatter: (params: ValueFormatterParams) => getSection(params.value),
  },
  {
    headerName: 'SAP Family',
    field: 'sapFamily',
    minWidth: 160,
    valueFormatter: (params: ValueFormatterParams) => getFamily(params.value),
  },
  {
    headerName: 'SAP Sub Family',
    field: 'sapSubFamily',
    minWidth: 170,
    valueFormatter: orDash,
  },
  {
    headerName: 'Store',
    field: 'store',
    valueFormatter: orDash,
  },
  {
    headerName: 'Aisle',
    field: 'aisle',
    valueFormatter: orDash,
  },
  {
    headerName: 'Shelf',
    field: 'shelf',
    valueFormatter: orDash,
  },
  {
    headerName: 'Facing',
    field: 'facing',
    valueFormatter: orDash,
  },
  {
    headerName: 'ERP Qty',
    field: 'erpQty',
    minWidth: 100,
  },
]
